// extracted by mini-css-extract-plugin
export var textInput = "_ho-0";